export default function StatusBadge({ status }) {
  const cls = `status-badge status-${status || "new"}`;
  const labels = { new: "New", reviewing: "Reviewing", offered: "Offered", closed: "Closed" };
  return <span className={cls} data-testid={`status-${status}`}>{labels[status] || status}</span>;
}
